import { isSaasPlatform } from './companyBranding.js';

/** Canonical marketing origin (matches index.html / primary domain). */
export const DEFAULT_SITE_ORIGIN = 'https://www.toolsandbubbles.com';
const SAAS_SITE_ORIGIN = 'https://serviceapp.ai';

/** True for local Vite / loopback origins that must never appear in SERP or customer URLs. */
export function isLoopbackPublicOrigin(origin: string): boolean {
  return /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/i.test(origin.trim());
}

function viteAppUrl(): string {
  try {
    return typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_URL
      ? String(import.meta.env.VITE_APP_URL)
          .trim()
          .replace(/\/+$/, '')
      : '';
  } catch {
    return '';
  }
}

function platformMarketingOrigin(): string {
  const fromEnv = viteAppUrl();
  if (fromEnv && !isLoopbackPublicOrigin(fromEnv)) return fromEnv;
  return isSaasPlatform() ? SAAS_SITE_ORIGIN : DEFAULT_SITE_ORIGIN;
}

/** Runtime marketing origin: tenant website, current host, or platform default. Never localhost. */
export function resolveMarketingSiteOrigin(websiteUrl?: string): string {
  const explicit = websiteUrl?.trim().replace(/\/$/, '') ?? '';
  if (explicit && !isLoopbackPublicOrigin(explicit)) return explicit;
  if (typeof window !== 'undefined') {
    const origin = window.location.origin.replace(/\/$/, '');
    if (!isLoopbackPublicOrigin(origin)) return origin;
  }
  return platformMarketingOrigin();
}

/** Turn a site path or absolute URL into an absolute URL for og:image and canonical fallbacks. */
export function toAbsoluteSiteUrl(pathOrUrl: string, origin: string = DEFAULT_SITE_ORIGIN): string {
  const o = origin.replace(/\/$/, '');
  const p = pathOrUrl.trim();
  if (!p) return `${o}${isSaasPlatform() ? '/serviceapp-icon-512.png' : '/icon-512.png'}`;
  if (/^https?:\/\//i.test(p)) return p;
  const path = p.startsWith('/') ? p : `/${p}`;
  return `${o}${path}`;
}
